import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/authContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-aawta-navy text-white">
        <div className="text-center">
          <div className="mx-auto w-10 h-10 border-2 border-white/25 border-t-aawta-magenta rounded-full animate-spin" />
          <div className="mt-4 text-sm text-white/70">Loading…</div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace state={{ from: location }} />;
  return children;
};

export default ProtectedRoute;
